import { Text } from "@marketplace/ui";
import { cva } from "class-variance-authority";
import { useTranslation } from "react-i18next";

type ProductStatusPillProps = {
  status: "ACTIVE" | "INACTIVE" | "PUBLISHED" | "DRAFT" | "UNPUBLISHED";
  onClick?: () => void;
};

const statusPill = cva(
  "flex justify-center items-center w-[120px] h-6 rounded",
  {
    variants: {
      status: {
        ACTIVE: "bg-[#E5FFDE] text-[#45B527]",
        INACTIVE: "bg-[#FFE7E7] text-[#8B1515]",
        PUBLISHED: "bg-[#E5FFDE] text-[#45B527]",
        UNPUBLISHED: "bg-[#FFF3E3] text-[#FF9500]",
        DRAFT: "bg-[#F4F4F4] text-fjord-grey-400"
      },
      clickable: {
        true: "cursor-pointer hover:opacity-80 transition-opacity",
        false: ""
      }
    }
  }
);

export const ProductStatusPill: React.FC<ProductStatusPillProps> = ({
  status,
  onClick
}) => {
  const { t } = useTranslation("product", {
    keyPrefix: "table.productList.status"
  });

  const statusLabel = {
    ACTIVE: t("active"),
    INACTIVE: t("inactive"),
    PUBLISHED: t("published"),
    DRAFT: t("draft"),
    UNPUBLISHED: t("unpublished")
  };

  return (
    <div
      className={statusPill({ status, clickable: !!onClick })}
      onClick={onClick}
    >
      <Text>{statusLabel[status]}</Text>
    </div>
  );
};
